import { ButtonStyle } from 'common/button';
import { NotificationType } from 'common/enums';
import { ModalWarning } from 'common/modal-warning';
import { appActions, AppContext } from 'context';
import { NotificationObject } from 'models/notificationObject';
import { VaultsController } from 'networking/controllers/vaults-controller';
import { useContext, useState } from 'react';

type RemoveCollaboratorsModalProps = {
  vaultsSelection: {
    id: number;
    selected: boolean | null;
    collaboratorsSelected: VaultCollaboratorType[];
  }[];
  amountSelected: number;
  notifyCollaboratorRemoved: (
    vault_id: number,
    collaborator_email: string,
  ) => void;
  onClose: () => void;
};

const RemoveCollaboratorsModal = ({
  vaultsSelection,
  amountSelected,
  notifyCollaboratorRemoved,
  onClose,
}: RemoveCollaboratorsModalProps) => {
  const { dispatch: generalDispatch } = useContext(AppContext);
  const [loading, setLoading] = useState(false);

  const removeSelectedCollaborators = async () => {
    setLoading(true);
    vaultsSelection.forEach((vault) =>
      vault.collaboratorsSelected.forEach(async (c) => {
        try {
          if (c.type === 'contributor' && c.invitationId) {
            await VaultsController.removeContributor({
              vaultId: vault.id,
              invitationId: c.invitationId,
            });
          } else {
            await VaultsController.removeGuest({
              guestId: c.id,
            });
          }
          notifyCollaboratorRemoved(vault.id, c.email);
        } catch (error) {
          generalDispatch({
            type: appActions.NOTIFICATION,
            notification: new NotificationObject({
              show: true,
              title: 'Collaborators Information',
              message: `Error removing collaborator ${c.email}`,
              type: NotificationType.Error,
            }),
          });
        }
      }),
    );
    setLoading(false);
  };

  return (
    <ModalWarning
      title="Remove selected collaborators"
      content={`Are you sure you want to remove ${amountSelected} collaborators? They will lose access to their vaults.`}
      successButtonText={`Remove ${amountSelected} editor`}
      successStyleButton={ButtonStyle.RedFilled}
      closeFn={onClose}
      loading={loading}
      successFn={removeSelectedCollaborators}
    />
  );
};

export { RemoveCollaboratorsModal };
